<template>
  <!-- <div style="background-color: #f2f2f2;height:100vh"> -->
  <!-- logo -->
  <!-- <div style="margin-bottom:50px">
      <img src="https://sso.uat.sims-cn.com//img/plus-logo.01196f52.png" alt="普乐师" style="height:44px; padding:20px" />
    </div>    -->
  <!-- 表单 -->
  <!-- <div class="form">
      <div class="login3form">
        <el-form ref="ruleForm2" :rules="rules2" :model="ruleForm2">
          <div style="color:#0DA4E9; font-size:26px;margin-bottom:20px">授权登录</div>
          <el-form-item prop="account">
              <el-input type="text" v-model="ruleForm2.account" auto-complete="off" placeholder="请输入CRM账号"
                  @keyup.enter.prevent.native="handleSubmit2" clearable :input="(ruleForm2.account)"></el-input>
          </el-form-item>
          <el-form-item prop="checkPass">
              <el-input type="password" v-model="ruleForm2.checkPass" auto-complete="off" placeholder="请输入密码"
                  @keyup.enter.prevent.native="handleSubmit2" clearable show-password></el-input>
          </el-form-item>
          <el-form-item>
              <el-button @click.native.prevent="handleSubmit2" :loading="logining" class="submit" type="primary" :disabled="!(ruleForm2.account&&ruleForm2.checkPass)">授&nbsp;&nbsp;权</el-button>
          </el-form-item>
       </el-form>
      </div>
    </div>
  </div> -->
  <div class="out flex_center">
    <div></div>
    <div class="flex_center">
      <img src="../common/images/login1.png" class="one" />
      <div
        style="color: #0da4e9; font-size: 26px; text-align: center"
        class="two"
      >
        您的租户用户无权登录CRM系统，<br /><br />请联系IT管理员
      </div>
    </div>
    <div
      class="login-a1"
      style="text-align: center"
      onclick="window.open('https://beian.miit.gov.cn')"
    >
      <h1>普乐师（上海）数字科技股份有限公司 沪ICP备16008893号-4</h1>
    </div>
  </div>
</template>

<script>
import utils from "../common/js/util";
import cook from "../common/js/cook";
export default {
  data() {
    return {
      logining: false,
      ruleForm2: {
        account: "",
        checkPass: "",
      },
      checked: false,
      canNotLogin: 0, //已经由于上个账号未注销而无法登陆的次数
      queryParams: {},
      bind: false, //是否需要进行绑定平台操作
      rules2: {
        account: [
          { required: true, message: "账号不能为空！", trigger: "blur" },
          //{ validator: validaePass }
        ],
        checkPass: [
          { required: true, message: "请输入密码！", trigger: "blur" },
          //{ validator: validaePass2 }
        ],
      },
    };
  },
  methods: {
    handleSubmit2(ev) {
      this.$refs.ruleForm2.validate((valid) => {
        if (valid) {
          this.logining = true;
          this.$http({
            method: "post",
            url: "/rest/auth/login",
            headers: {
              "Content-type": "application/x-authc-username-password+json",
            },
            data: {
              user: this.ruleForm2.account,
              password: this.ruleForm2.checkPass,
            },
          })
            .then(async (res) => {
              //因为后台不允许同一个客户端登录两个账号，所以如果登陆了一个账号这里就提示他需要先注销
              //当前请求登录的账号和服务端返回的‘已经登录的账号’名称不匹配时，则判定是第二次登陆
              console.log(
                "loginName = " +
                  res.data.loginName +
                  "  account=" +
                  this.ruleForm2.account
              );
              if (res.data.loginName != this.ruleForm2.account) {
                if (this.canNotLogin <= 1) {
                  this.$alert(
                    "您已经在本浏览器中登录了另一个账号，必须注销后才能重新登陆，本次登录无效",
                    "提示",
                    { type: "error" }
                  );
                } else {
                  //如果连续2次没进去，则允许强制退出
                  this.$confirm(
                    "您已经在本浏览器中登录了另一个账号，必须注销后才能重新登陆,  是否强制注销?",
                    "提示",
                    {
                      type: "warning",
                    }
                  )
                    .then(() => {
                      this.$http
                        .post("/rest/auth/logout")
                        .then((res) => {
                          utils.myNotify(this, "success", res, "注销成功"); //有时候提示该用户未登入，此时code是一串字母，但我们仍然提示注销成功
                          sessionStorage.clear();
                          setTimeout(() => {
                            location.reload(true);
                          }, 1000);
                        })
                        .catch((err) => {
                          utils.myNotify(
                            this,
                            "warning",
                            err.response,
                            "注销失败"
                          );
                        });
                    })
                    .catch(() => {});
                }
                this.canNotLogin += 1;
              } else {
                let resbindAccount = await this.bindAccount();
                if (resbindAccount !== true) {
                  console.log(222);
                  return;
                }
                //正常情况下直接登录
                this.checked
                  ? localStorage.setItem("user", String(res.data.loginName))
                  : localStorage.clear();
                //localstorage对应‘记住账号’，sessionstorage不论如何都存，仅在本标签页有效
                sessionStorage.setItem("user", String(res.data.loginName));
                sessionStorage.setItem(
                  "passwords",
                  String(this.ruleForm2.checkPass)
                );
                sessionStorage.setItem("nickname", String(res.data.nickname));
                cook.setCookie("user", String(res.data.loginName), 7200);
                //登录成功后获取权限
                this.$http({
                  method: "GET",
                  url: "/rest/sysUser/sysUserLogin",
                  params: {
                    account: this.ruleForm2.account,
                    password: this.ruleForm2.checkPass,
                  },
                })
                  .then((res) => {
                    //成功后自动跳转到第一个有权限的页面，缺点是顺序被后台控制
                    let webIdArr = [];
                    let pathArr = [];
                    let data = res.data;
                    let routes = this.$router.options.routes;
                    data.webAuthLst.map((item) => {
                      webIdArr.push(item.webId);
                    });
                    routes.map((item) => {
                      item.children.map((item2) => {
                        if (webIdArr.indexOf(item2.webId) > -1) {
                          pathArr.push(item2.path);
                        }
                      });
                    });
                    //这里其实可以优化，不等map结束，就可以跳转了，但也就几毫秒，无所谓
                    if (pathArr.length > 0) {
                      this.$router.push({ path: pathArr[0] });
                    } else {
                      this.$router.push({ path: "/noPermission" });
                    }
                    //获取登录人webid44的权限 给qhr页面权限使用
                    data.webAuthLst.forEach((item) => {
                      if (item.webId == 44) {
                        sessionStorage.setItem(
                          "webId_44Auth",
                          String(item.auth)
                        );
                      }
                    });
                    sessionStorage.setItem(
                      "account",
                      String(res.data.sysUser.account)
                    );
                    sessionStorage.setItem(
                      "sysUserId",
                      String(res.data.sysUser.id)
                    );
                    sessionStorage.setItem(
                      "empPk",
                      String(res.data.sysUser.empPk)
                    );
                  })
                  .catch((err) => {
                    utils.myNotify(
                      this,
                      "error",
                      err.response,
                      "获取用户权限信息失败，请稍后重试"
                    );
                  });
                this.$alert("授权成功", "提示", { type: "success" });
              }
              this.logining = false;
            })
            .catch((err) => {
              utils.myNotify(this, "error", err.response, "登录失败");
              this.logining = false;
            });
        }
      });
    },
    bindAccount() {
      return new Promise(async (resolve, reject) => {
        let res = await this.$http({
          method: "post",
          url: "/rest/crmAccessFmes/saveAccessFmesUser",
          data: {
            account: this.ruleForm2.account,
            password: this.ruleForm2.checkPass,
            tenantCode: this.$route.query.tenantCode,
          },
        }).catch((err) => {
          utils.myNotify(this, "error", err.response, "绑定失败");
        });
        if (res.data.code === "0") {
          console.log(res.data.code);
          resolve(true);
        }
      });
    },
  },
  mounted() {
    // this.ruleForm2.account = localStorage.getItem('user') || '';
    setTimeout(() => {
      (this.ruleForm2.account = ""), (this.ruleForm2.checkPass = "");
    }, 0);
  },
};
</script>

<style lang="scss" scoped>
.flex_center {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
.out {
  height: 100vh;
  .one {
    width: 200px;
    margin-bottom: 20px;
  }
  .two {
    padding: 35px;
    background: #fff;
    border: 1px solid #eaeaea;
    border-radius: 5px;
  }
}
.form {
  display: flex;
  justify-content: center;
  align-items: center;
}
.login3form {
  padding: 50px 56px 60px;
  height: 350px;
  width: 550px;
  box-sizing: border-box;
  background: #fff;
}
.submit {
  margin-top: 30px;
  width: 100%;
  border-radius: 3px;
  font-size: 18px;
}
.el-input {
  font-size: 16px;
}
.el-button {
  border-color: #e6e6e6;
  font-size: 16px;
  color: #b8b8b8;
}
.el-button--primary {
  color: #fff;
  background-color: #008bcf;
}
.el-button--primary.is-disabled {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f5f5f5;
}
.login-a1 {
  text-align: center;
  font-size: 16px;
  font-family: "微软雅黑";
  color: #fff;
  margin: 40px 40px 20px;
  height: 40px;
  line-height: 40px;
  padding: 0;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/Login3.vue